
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    page: { type: Object, required: true },
  },
  computed: {
    publicationLanguage() {
      return this.page.language === 'nl' && this.page.publicationLanguage === 'English' ? 'en' : undefined
    },
  },
})
